import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';
import { tap } from 'rxjs/operators';

const baseUrl = `${environment.apiBaseUrl}platform/dashboards`;

@Injectable({
  providedIn: SharedModule
})
export class DashboardService {

  dashboardConstants = new Map();

  constructor(private http: HttpClient) { }

  get(id): Observable<Dashboard.DashboardModel> {
    return this.http.get<Dashboard.DashboardModel>(`${baseUrl}/${id}`).pipe(
      tap(resp => {
        this.dashboardConstants.set('constants', resp.constants);
      })
    );
  }

  list(): Observable<Dashboards.DashboardsModel[]> {
    return this.http.get<Dashboards.DashboardsModel[]>(`${baseUrl}`);
  }

  create(dashboard: any): Observable<Dashboard.DashboardModel> {
    return this.http.post<Dashboard.DashboardModel>(`${baseUrl}`, dashboard);
  }

  update(dashboard: any): Observable<Dashboard.DashboardModel> {
    return this.http.put<Dashboard.DashboardModel>(`${baseUrl}/${dashboard.id}`, dashboard);
  }

  getRefresh(dashboardId: any): Observable<any> {
    return this.http.post<any>(`${baseUrl}/${dashboardId}/refresh`, {})
  }

  delete(dashboardId: string): Observable<any> {
    return this.http.delete<any>(`${baseUrl}/${dashboardId}`);
  }

  favoriteDashboard(dashboardId: string): Observable<Dashboard.DashboardModel> {
    return this.http.put<Dashboard.DashboardModel>(`${baseUrl}/${dashboardId}/favorite`, dashboardId);
  }

  // widget create
  createWidget(dashboardId, widget, scopeId?: string): Observable<any> {
    let params = new HttpParams();
    if (scopeId) {
      params = params.append('scope', scopeId)
    }
    return this.http.post<any>(`${baseUrl}/${dashboardId}/widgets`, widget, {params});
  }

  // manage dashboard
  manageDashboard(dashboard: any): Observable<any> {
    return this.http.put<any>(`${baseUrl}/${dashboard.id}/manage`, dashboard);
  }

  // get fields
  fields(id?: string): Observable<any> {
    return this.http.get<any>(id ? `${baseUrl}/${id}/fields` : `${baseUrl}/fields`);
  }

  // get dashboard info
  dashboardInfo(id: string): Observable<Dashboard.Info> {
    return this.http.get<Dashboard.Info>(`${baseUrl}/${id}/info`);
  }
}
